(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/components/terminate-team-popover-item.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/components/terminate-team-popover-item.js');
'use strict';

const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory;
const _svs$arena$pages$team = svs.arena.pages.teams.dialogs,
  showTechnicalError = _svs$arena$pages$team.showTechnicalError,
  showDeleteTeamSuccess = _svs$arena$pages$team.showDeleteTeamSuccess,
  showDeleteTeamQuestionDialog = _svs$arena$pages$team.showDeleteTeamQuestionDialog,
  showDeleteTeamSuccessAlt = _svs$arena$pages$team.showDeleteTeamSuccessAlt;
const TEAMS = svs.arena.constants.routes.TEAMS;
const removeTeam = svs.arena.store.teams.actions.removeTeam;
const putTerminateSyndicateAsync = svs.arena.service.teamsService.putTerminateSyndicateAsync;
const MemberPopoverItem = svs.arena.pages.teams.components.MemberPopoverItem;
const TerminateTeamPopoverItem = _ref => {
  let teamName = _ref.teamName,
    teamId = _ref.teamId,
    amount = _ref.amount;
  const dispatch = ReactRedux.useDispatch();
  const history = useHistory();
  const handleClick = async () => {
    if (!(await showDeleteTeamQuestionDialog(teamName))) {
      const track = {
        category: 'spela-tillsammans',
        action: 'finish_team',
        opt_label: 'cancel'
      };
      svs.components.analytics.trackEvent(track);
      return;
    }
    const _await$putTerminateSy = await putTerminateSyndicateAsync(teamId),
      error = _await$putTerminateSy.error;
    if (error) {
      showTechnicalError();
      return;
    }
    const track = {
      category: 'spela-tillsammans',
      action: 'finish_team',
      opt_label: 'delete'
    };
    svs.components.analytics.trackEvent(track);
    if (parseInt(amount, 10) > 0) {
      showDeleteTeamSuccessAlt(teamName, amount);
    } else {
      showDeleteTeamSuccess(teamName);
    }
    history.push(TEAMS);
    dispatch(removeTeam(teamId));
  };
  return React.createElement(MemberPopoverItem, {
    onClick: handleClick
  }, "Avsluta laget");
};
svs.arena.pages.teams.components.TerminateTeamPopoverItem = TerminateTeamPopoverItem;

 })(window);